export default __webpack_public_path__ + "static/media/illustration.77d9214c.svg";